import React from 'react'
import { t } from 'ttag'

class ProfileSectionJobListing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      jobs: props.section.additional,
      currentPage: 1,
      totalPages: 1
    }
  }

  //add job log call
  logView(jo) {
    if (jo.newWindow) {
      window.open(jo.url, '_blank')
    } else {
      window.location.href = jo.url
    }
  }

  outputTable(section) {
    return section.map(s => (
      <tr className="list" key={s.url}>
        <td className="item">
          <a
            href={s.url}
            onClick={e => {
              e.preventDefault()
              console.log(e, s)
              this.logView(s)
            }}
            className="normal-listing"
            target={s.newWindow ? '_self' : '_blank'}
            rel="noreferrer">
            {s.title}
          </a>
        </td>
        <td className="item">{s.location}</td>
        <td className="item">{new Date(s.datePosted).toLocaleDateString('en-US')}</td>
      </tr>
    ))
  }

  render() {
    const section = this.state.jobs

    if (!section) {
      return null
    }

    return (
      <table className="table noround">
        <thead>
          <tr className="table-head">
            <th>{t`Position`}</th>
            <th>{t`Location`}</th>
            <th>{t`Date Posted`}</th>
          </tr>
        </thead>
        <tbody>{this.outputTable(section)}</tbody>
      </table>
    )
  }
}

export default ProfileSectionJobListing
